
/* injects from baggage-loader */

'use strict';

import ProjectInvestmentWizardStep2Component from './projectinvestmentwizard.step2.component';

const ProjectInvestmentWizardStep2PageModule = angular.module('project-investment-wizard-step-2-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('projectinvestmentwizard.info', {
        url: '/investor-info',
        component: 'projectInvestmentWizardStep2',
        // Resolve promises into controller bindings, see component for bindings
        // resolve: { }
      });
  })
  .component('projectInvestmentWizardStep2', new ProjectInvestmentWizardStep2Component());

export default ProjectInvestmentWizardStep2PageModule;



// WEBPACK FOOTER //
// ./src/app/pages/projectInvestmentWizard/step2/projectinvestmentwizard.step2.module.js